$.fn.stickyFooter = function (options) {
  	'use strict';

  	var _elem = $(this),  // instance to $('#selector')
      	_this = this,     // instance to this plugin
        _didResize = false,
        _resized = false;

  	// custom variables
  	var o = $.extend({

  	}, options);


  	_this.init = function () {
      _didResize = false;
      _this.bumpIt();
  	};

    _this.bumpIt = function() {
      $('body').css('margin-bottom', _elem.innerHeight());
    };

    _this.resize = function() {
      clearTimeout(_resized);
      _resized = setTimeout(function() {
        _this.bumpIt();
      }, 150);
    };

    $(window).resize(function() {
      _this.resize();
    });

  	_this.init();
};